// Simple example of a React "smart" component

import { connect } from 'react-redux';
import TeamManager from '../components/TeamManager';
import * as actions from '../actions/teamManagerActionCreators';

// Which part of the Redux global state does our component want to receive as props?
const mapStateToProps = (state) => ({
  venueOwnerships: state.venueOwnerships,
  teamMemberships: state.teamMemberships,
  pendingInvitations: state.pendingInvitations,
  addingNewInvitation: state.addingNewInvitation,
  newInvitation: state.newInvitation,
  roles: state.roles,
  csrfToken: state.csrfToken,
  team: state.team,
  newInvitationEnableAllVenues: state.newInvitationEnableAllVenues,
  newInvitationSubmitting: state.newInvitationSubmitting,
  teamManageableToEdit: state.teamManageableToEdit,
  teamManageableToEditEnableAllVenues: state.teamManageableToEditEnableAllVenues,
  // New state for redesign
  searchTerm: state.searchTerm,
  roleFilter: state.roleFilter,
  venueFilter: state.venueFilter,
  currentPage: state.currentPage,
  pageSize: state.pageSize,
  sortBy: state.sortBy,
  sortDirection: state.sortDirection,
  selectedMemberIds: state.selectedMemberIds,
  memberModalOpen: state.memberModalOpen,
  memberModalMode: state.memberModalMode,
  teamFunctions: state.teamFunctions,
  teamFunctionFilter: state.teamFunctionFilter
});

const mapDispatchToProps = (dispatch) => {
  return {
    addTeamMemberClicked: () => dispatch(actions.addTeamMemberClicked()),
    cancelNewInvitation: () => dispatch(actions.cancelNewInvitation()),
    newInvitationFirstNameChanged: (firstName) => dispatch(actions.newInvitationFirstNameChanged(firstName)),
    newInvitationLastNameChanged: (lastName) => dispatch(actions.newInvitationLastNameChanged(lastName)),
    newInvitationEmailChanged: (email) => dispatch(actions.newInvitationEmailChanged(email)),
    newInvitationRoleIdChanged: (roleId) => dispatch(actions.newInvitationRoleIdChanged(roleId)),
    newInvitationCompanyChanged: (company) => dispatch(actions.newInvitationCompanyChanged(company)),
    newInvitationVenueOwnershipClicked: (venueOwnershipId) => dispatch(actions.newInvitationVenueOwnershipClicked(venueOwnershipId)),
    createInvitation: (csrfToken, venueOwnerships, invitation, team) => dispatch(actions.createInvitation(dispatch, csrfToken, venueOwnerships, invitation, team)),
    newInvitationEnableAllVenuesClicked: (venueOwnerships) => dispatch(actions.newInvitationEnableAllVenuesClicked(venueOwnerships)),
    newInvitationDisableAllVenuesClicked: () => dispatch(actions.newInvitationDisableAllVenuesClicked()),
    editTeamManageable: (teamManageable, venueOwnerships) => dispatch(actions.editTeamManageable(teamManageable, venueOwnerships)),
    cancelEditTeamManageable: (teamManageable) => dispatch(actions.cancelEditTeamManageable(teamManageable)),
    deleteTeamManageable: (csrfToken, team, teamManageable, closeModal) => dispatch(actions.deleteTeamManageable(dispatch, csrfToken, team, teamManageable, closeModal)),
    teamManageableToEditUpdateFirstName: (firstName) => dispatch(actions.teamManageableToEditUpdateFirstName(firstName)),
    teamManageableToEditUpdateLastName: (lastName) => dispatch(actions.teamManageableToEditUpdateLastName(lastName)),
    teamManageableToEditUpdateEmail: (email) => dispatch(actions.teamManageableToEditUpdateEmail(email)),
    teamManageableToEditUpdateRoleId: (roleId) => dispatch(actions.teamManageableToEditUpdateRoleId(roleId)),
    teamManageableToEditVenueOwnershipClicked: (venueOwnershipId) => dispatch(actions.teamManageableToEditVenueOwnershipClicked(venueOwnershipId)),
    teamManageableToEditEnableAllVenuesClicked: (venueOwnerships) => dispatch(actions.teamManageableToEditEnableAllVenuesClicked(venueOwnerships)),
    teamManageableToEditDisableAllVenuesClicked: () => dispatch(actions.teamManageableToEditDisableAllVenuesClicked()),
    submitUpdateTeamManageable: (csrfToken, team, teamManageable) => dispatch(actions.submitUpdateTeamManageable(dispatch, csrfToken, team, teamManageable)),
    teamManageableToEditErrorsChanged: (errors) => dispatch(actions.teamManageableToEditErrorsChanged(errors)),
    resetPasswordForEmail: (csrfToken, teamMembership, team) => dispatch(actions.resetPasswordForEmail(dispatch, csrfToken, teamMembership, team)),
    teamManageableToEditCompanyChanged: (company) => dispatch(actions.teamManageableToEditCompanyChanged(company)),
    // New action creators for redesign
    searchTermChanged: (searchTerm) => dispatch(actions.searchTermChanged(searchTerm)),
    roleFilterChanged: (roleFilter) => dispatch(actions.roleFilterChanged(roleFilter)),
    venueFilterChanged: (venueFilter) => dispatch(actions.venueFilterChanged(venueFilter)),
    currentPageChanged: (currentPage) => dispatch(actions.currentPageChanged(currentPage)),
    pageSizeChanged: (pageSize) => dispatch(actions.pageSizeChanged(pageSize)),
    toggleMemberSelection: (memberId) => dispatch(actions.toggleMemberSelection(memberId)),
    selectAllMembers: (memberIds) => dispatch(actions.selectAllMembers(memberIds)),
    deselectAllMembers: () => dispatch(actions.deselectAllMembers()),
    clearFilters: () => dispatch(actions.clearFilters()),
    sortChanged: (sortBy, sortDirection) => dispatch(actions.sortChanged(sortBy, sortDirection)),
    openMemberModal: (mode) => dispatch(actions.openMemberModal(mode)),
    closeMemberModal: () => dispatch(actions.closeMemberModal()),
    createTeamFunction: (csrfToken, team, name) => dispatch(actions.createTeamFunction(csrfToken, team, name)),
    updateTeamFunction: (csrfToken, team, teamFunction, name) => dispatch(actions.updateTeamFunction(csrfToken, team, teamFunction, name)),
    deleteTeamFunction: (csrfToken, team, teamFunction) => dispatch(actions.deleteTeamFunction(csrfToken, team, teamFunction)),
    teamFunctionFilterChanged: (selectedTeamFunctionId) => dispatch(actions.teamFunctionFilterChanged(selectedTeamFunctionId)),
    newInvitationTeamFunctionIdsChanged: (teamFunctionIds) => dispatch(actions.newInvitationTeamFunctionIdsChanged(teamFunctionIds)),
    teamManageableToEditTeamFunctionIdsChanged: (teamFunctionIds) => dispatch(actions.teamManageableToEditTeamFunctionIdsChanged(teamFunctionIds))
  }
};

// Don't forget to actually use connect!
// Note that we don't export HelloWorld, but the redux "connected" version of it.
// See https://github.com/reactjs/react-redux/blob/master/docs/api.md#examples
export default connect(mapStateToProps, mapDispatchToProps)(TeamManager);
